module.exports = __webpack_public_path__ + "img/av-primary.388cf594.png";